import { useState } from 'react';

import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import {
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_SORT_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_SORT_OPTION_MODEL,
} from './models';
import {
  useAccountUserDetailLikeProductListQuery,
  useAccountUserDetailLikeProductLogListQuery,
  useAccountUserLikeProductDetailQuery,
} from './query';
import { getTablePages } from '../../../../../lib/utils/tableUtils';

export const useAccountUserLikeProductDetail = ({ userId, isActive }) => {
  const { data } = useAccountUserLikeProductDetailQuery({
    userId,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_LIKE_PRODUCT_DETAIL_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => result.data.likeProductSummaryData,
    },
  });

  return data;
};

export const useAccountUserDetailLikeProductList = ({ userId, isActive }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_FILER_OPTION_MODEL);
  const [sortOption, setSortOption] = useState(ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_SORT_OPTION_MODEL);

  const { data } = useAccountUserDetailLikeProductListQuery({
    userId,
    pagination,
    filterOption,
    sortOption,
    options: {
      enabled: !!userId && isActive,
      keepPreviousData: true,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_LIKE_PRODUCT_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        list: result.data.likeProductHistory.list,
        totalCnt: result.data.likeProductHistory.totalCnt,
        mainProductCategorySelectList: result.data.likeProductHistory.mainProductCategorySelectList,
        subProductCategorySelectList: result.data.likeProductHistory.subProductCategorySelectList,
      }),
    },
  });

  const getList = ({ pagination, sortOption, filterOption }) => {
    pagination && setPagination(pagination);
    sortOption && setSortOption(sortOption);
    filterOption && setFilterOption(filterOption);
  };

  return { likeProductHistory: data, filterOption, sortOption, getList };
};

export const useAccountUserDetailLikeProductLogList = ({ userId, actionLogType, setActionLogType }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_FILER_OPTION_MODEL);
  const [sortOption, setSortOption] = useState(ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_SORT_OPTION_MODEL);

  const { data } = useAccountUserDetailLikeProductLogListQuery({
    userId,
    pagination,
    filterOption,
    sortOption,
    actionLogType,
    options: {
      enabled: !!userId,
      keepPreviousData: true,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        logList: result.data.likeProductLogList,
        totalCnt: result.data.totalCnt,
        mainProductCategorySelectList: result.data.mainProductCategorySelectList,
        subProductCategorySelectList: result.data.subProductCategorySelectList,
      }),
    },
  });

  const getList = ({ pagination, sortOption, filterOption }) => {
    pagination && setPagination(pagination);
    sortOption && setSortOption(sortOption);

    if (filterOption) {
      setActionLogType(filterOption.actionLogType);
      setFilterOption(filterOption);
    }
  };

  return {
    likeProductLogList: data,
    filterOption: { ...filterOption, actionLogType },
    sortOption,
    pagination: { ...pagination, pages: getTablePages(data.totalCnt, pagination.pageSize) },
    getList,
  };
};
